export const requestUrl = {
  // 登录注册模块
  login: {
    getHeadingCode: '/login/code', // 获取识别码
    getVerificationCode: '/login/text/', // 获取验证码
    commonRegister: '/login/visitor/registry', // 普通用户注册
    commonLogin: '/login/visitor', // 普通用户登录
    gardenLogin: '/login/basement', // 园区用户登录
    forgetPassword: '/login/visitor/forget' // 忘记密码
  },
  // 用户中心模块
  user: {
    logOut: '/user/logout', // 登出
    ChangePassword: '/user/password/update', // 修改密码
    userApplyRecord: '/user/enrollInfo/get' // 报名记录
  },
  // 首页
  home: {
    indexInfo: '/index/get', // 首页信息
    footerInfo: '/index/get/bottom'// 布局底部信息
  },
  // 通知模块
  inform: {
    informData: '/info/inner/get', // 通知页
    informDetail: '/info/innerInfoDetails', // 通知详情页
    informReaderData: '/info/inner/statistic', // 通知详情阅读数量
    informationReaderData: '/info/outer/statistic', // 资讯详情阅读数量
    policynReaderData: '/info/policy/statistic', // 政策详情阅读数量
    courseReaderData: '/info/alliance/statistic' // 联盟历程详情阅读数量
  },
  // 资讯模块
  information: {
    informationData: '/info/outer/get', // 资讯页
    informationDetail: '/info/outerInfoDetails' // 资讯详情页
  },
  // 活动模块
  activity: {
    HCMegagameData: '/activity/competition', // 海创大赛首页
    HCMegagameSpecificData: '/activity/competition/get/', // 具体某项大赛数据
    HCAwardProject: '/activity/project/filter', // 大赛优秀项目数据
    HCMegagamePeriod: '/activity/get/session', // 大赛优秀项目入围届次
    HCExcellentProjectDetail: '/activity/project/get/', // 大赛优秀项目详情
    applyCondition: '/activity/competition/enroll/', // 是否符合大赛报名条件
    submitApplyForm: '/activity/competition/enroll', // 提交报名表单
    firmElect: '/activity/appraise', // 企业评选首页
    firmElectSpecificData: '/activity/appraise/get/', // 具体某个企业数据
    FirmBeSelectedData: '/activity/company/filter', // 入选企业数据
    firmClassify: '/activity/get/industryList', // 企业所属行业
    firmGarden: '/activity/get/basement', // 企业所属园区
    webAnnualMeeting: '/activity/annual', // 网络年会首页
    webAnnualMeetingSpecificData: '/activity/annual/get/', // 具体某届网络年会数据
    activityMagazine: '/activity/appraise/magazine', // 企业评选下的企业发展报告
    elseActiveData: '/activity/others' // 其他活动
  },
  // 基地模块
  base: {
    priorBasement: '/entity/priorBasement', // 基地发展报告与案例
    commonCity: '/common/get', // 查找34个省和直辖市
    city: '/common/get/children/', // 查找二级地区
    priorBasementSearch: '/entity/priorBasement/search', // 根据搜索查询基地
    priorBasementMagazine: '/entity/priorBasement/magazine/report', // 基地发展报告pdf
    priorBasementExample: '/entity/priorBasement/magazine/example' // 基地案例pdf
  },
  // 园区模块
  garden: {
    coreData: '/entity/basement/statistic/district/', // 园区核心数据表
    coreData2: '/entity/basement/statistic/children/', // 园区核心数据表(2)
    AreaGarden: '/entity/basement/search', // 各地区园区排比
    AbroadList: '/entity/basement/prior/search', // 留创园区列表
    garderDetail: '/entity/basement/get/', // 园区详情页
    GardenFirmList: '/entity/company/basement/filter'// 园区详情页企业列表

  },
  // 企业模块
  firm: {
    firmNum: '/entity/company/nums', // 地区企业数量
    firmList: '/entity/company/filter', // 企业列表
    firmDetail: '/entity/company/get/', // 企业详情页
    AbroadFirmNum: '/backend/company/total'// 留创企业数
  },
  // 杂志模块
  magazine: {
    association: '/magazine/association', // 杂志会刊
    annual: '/magazine/annual'// 杂志年刊
  },
  // 联盟模块
  league: {
    leagueserveSystem: '/alliance/serviceStructure', // 联盟服务体系
    leagueIntroduce: '/alliance/introduction', // 联盟介绍
    leagueRule: '/alliance/regulation', // 联盟章程
    leagueorganization: '/alliance/structure', // 联盟组织机构
    leagueorDevelopment: '/alliance/develop', // 联盟发展历程
    joinLeague: '/alliance/join'// 加入联盟
  },
  // 政策模块
  policy: {
    policyData: '/policy/search', // 政策页
    policyDetail: '/policy/infoDetails' // 政策详情页
  },
  // 站内搜索模块
  search: {
    standSearch: '/inner/get' // 站内搜索
  },
  // 服务模块
  serve: {
    readerNum: '/getBrowserAggregation', // 阅读数量统计
    tbService: '/api/tbService/get'
  },
  // 园区后台园区信息管理模块
  gardenInfoManage: {
    gardenBaseInfo: '/backend/basement/getBasementInfo', // 园区基本信息
    gardenUpLoadInfo: '/backend/basement/update' // 园区信息上传
  },
  // 园区后台企业信息管理模块
  companyInfoManage: {
    backendAudit: '/backend/audit/get', // 提交基地年审
    backendTemplate: '/backend/audit/template', // 年审模板
    upload: '/common/upload', // 年审模板
    audit: '/backend/audit/update', // 年审提交
    getLatestAudit: '/backend/audit/getLatestAudit', // 年审提交

    firmNameSuggest: '/entity/fuzzySearch', // 企业名模糊查询
    firmBaseInfo: '/entity/gelanda', // 企业基本信息
    firmIntellectualProperty: '/entity/patentNum', // 企业知识产权数
    firmDataUp: '/backend/company/insert', // 企业数据上传(新增)
    firmDataChange: '/backend/company/update', // 企业数据上传(修改)
    publishUpdate: '/backend/company/publishUpdate', // 上下线
    firmArea: '/backend/getDistrict'// 企业所在园区所属地区
  },
  // 园区后台提交基地年审模块
  submitBaseVerification: {
    text: '/common/oss/policy/test'
  }
}
